import { render, staticRenderFns } from "./MedcardShareSelectItems.vue?vue&type=template&id=32d75939"
import script from "./MedcardShareSelectItems.vue?vue&type=script&lang=ts"
export * from "./MedcardShareSelectItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseCheckbox: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseCheckbox.vue').default,BaseBtn: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBtn.vue').default})
